import { Instance, types } from 'mobx-state-tree';

export const Language = types.model('Language', {
  localeCode: types.string,
  localName: types.string
});

export type Language = Instance<typeof Language>;
